export enum RightSidebarOption {
  AI_BOT = 'AI_BOT',
  COMMENTS = 'COMMENTS',
}
